import Vue from "vue"

Vue.filter('highlightText', function (value, query) {
    if (!value || !query) return value;

    const regex = new RegExp(query, "gi");

    return String(value).replace(regex, (match) => {
        return `<span class='orange'>${match}</span>`;
    });
});

Vue.filter('truncate', function (value, limit) {
    if (!value) {
        return value
    }
    return value.length > limit ? value.substring(0, limit) + '...' : value
})